import { environment } from "src/environments/environment";

export const PREFIX = '/api';

const GAI_SERVICE = '/gaim-service';

// Using URLs from environment variables
const ORDER_SERVICE = environment.orderService;
const RATING_SERVICE = environment.ratingService;
export const API_AUTH = environment.authService;
const JOB_SERVICE = environment.jobService;
const NOTIFICATION_SERVICE = environment.notificationService;
const JOB_SEEKER_SERVICE = environment.jobSeekerService;
export const API_ENTERPRISE_ADMIN = environment.enterpriseAdminService;
const CALLING_SERVICE = environment.callingService;
const PROJECT_API = environment.projectAPI;
const GOOGLE_INTEGRATION_API = environment.projectAPI

export const API_ACCOUNT = API_AUTH + '/v1/account';
export const API_ACCOUNT_CREDIT = API_AUTH + '/v1/enterprise/entity/usage';
export const API_EMPLOYER = API_AUTH + '/v1/employer';
export const API_EMPLOYER_UPLOAD = API_AUTH + '/v1/fileupload/employer';
export const API_EMPLOYER_CONTRACT = API_AUTH + '/v1/fileupload/EMPLOYER_CONTRACT';
export const API_EMPLOYER_SIGNATURE = API_AUTH + '/v1/fileupload/employer/signature';
export const API_EMPLOYER_SIGN_CONTRACT = API_AUTH + '/v1/employer/sign-contract';
export const API_ENTERPRISE_SIGN_CONTRACT = API_AUTH + '/v1/enterprise/sign-contract';

export const API_CREATE_ENTITY = API_AUTH + '/v1/enterprise/entity';
export const API_UPDATE_ENTITY_PROFILE = API_AUTH + '/v1/enterprise/edit-entity-profile';
export const API_UPDATE_ENTITY = API_AUTH + '/v1/enterprise/entity/update';
export const API_UPDATE_USER_ENTITY = API_AUTH + '/v1/enterprise/update-entity-user';
export const API_ADD_AGENCY = API_AUTH + '/v1/enterprise/add-entity/';
export const API_INVITE_AGENT = API_AUTH + '/v1/enterprise/invite/';
export const API_ADD_CHAMP = API_AUTH + '/v1/enterprise/add-entity';
export const API_ADD_TEAM_MEMBER = API_AUTH + '/v1/enterprise/user-mapping';
export const API_APPROVE_TEAM_MEMBER = API_AUTH + '/v1/enterprise/user_mapping';
export const API_APPROVE_AGENCY = API_AUTH + '/v1/enterprise/entity_mapping/';
export const API_FETCH_AGENCY = API_AUTH + '/v1/enterprise/entity_mapping';
export const API_FETCH_TEAM_MEMBER = API_AUTH + '/v1/enterprise/user_mapping';
export const API_FETCH_TEAM_MEMBER_V2 = API_AUTH + '/v1/enterprise/user_mapping_v2';
export const API_FETCH_ENTITIES = API_AUTH + '/v1/enterprise/hoa/entity_mapping';
export const SEND_OTP = API_AUTH + '/v1/enterprise/otp';
export const VERIFY_OTP_WITH_DETAILS = API_AUTH + '/v1/enterprise/v2/otp/verify';
export const CHANGE_RESET_PASSWORD = API_AUTH + '/v1/enterprise/verify-reset-password';
export const PLIVO_PHONE_NUMBER = API_AUTH + '/v1/phone-number/search/plivo?country_iso=IN&services=voice&limit=10&type=local'
export const PURCHASED_PHONE_NUMBERS = API_AUTH + '/v1/phone-number';
export const PURCHASE_PHONE_NUMBER = PURCHASED_PHONE_NUMBERS + '/buy';
export const ACTIVATE_PHONE_NUMBER = API_AUTH + '/v1/phone-number/activate';

// Job SERVICE

export const API_JOB = JOB_SERVICE + '/v1/job';
export const API_MULTIPLE_PICTURE_UPLOAD = JOB_SERVICE + '/v1/fileupload/workOrderhistory/mulitple-uploads';
export const API_JOB_APPLICATION = JOB_SERVICE + '/v1/jobapplication';
export const API_JOB_APPLICATION_V2 = JOB_SERVICE + '/v2/jobapplication';
export const API_EMPLOYEE_ATTENDANCE = JOB_SERVICE + '/v1/employmentAttendance';
export const API_TIMESHEET = JOB_SERVICE + '/v1/employmentAttendance/time-sheet';
export const API_TIMESHEET_FILTER = JOB_SERVICE + '/v1/employmentAttendance/time-sheet/filter';
export const API_JOB_CATEGORY = JOB_SERVICE + '/v1/jobCategory';
export const API_JOB_TYPE = JOB_SERVICE + '/v1/jobType';
export const API_MY_JOB = JOB_SERVICE + '/v1/mobile/myjobs';
export const API_STATS = JOB_SERVICE + '/v1/stats';
export const API_WORKLOG = JOB_SERVICE + '/v1/worklog';
export const API_CANCEL_SHIFT = JOB_SERVICE + '/v1/employment/cancel';
export const API_CHECKOUT_SHIFT = JOB_SERVICE + '/v1/employment/checkout-link';
export const API_FETCH_DASHBOARD = JOB_SERVICE + '/v1/enterprise/workOrder/getAllWorkOrder';
export const API_ACTIVATION_PROOF = JOB_SERVICE + '/v1/workOrder/activation-proof/';
export const UploadAttendancePicture = JOB_SERVICE + '/v1/fileupload/workOrderhistory';
export const SaveAttendanceImgProof = JOB_SERVICE + '/v1/employmentHistory/imageproof';
export const SaveAttendanceImgProofs = JOB_SERVICE + '/v1/employmentHistory/imageproofs';
export const UpdateAttendanceImgProof = JOB_SERVICE + '/v1/employmentHistory/updateimageproof';
export const UpdateAttendanceImgProofStatus = JOB_SERVICE + '/v1/employmentHistory/update-status';
export const DeleteAttendanceImgProof = JOB_SERVICE + '/v1/employmentHistory/deleteimageproof';
export const GET_QUOTATION = JOB_SERVICE + '/v1/job/quotation';
export const GET_PO = JOB_SERVICE + '/v1/job/purchase-order';
export const GET_PROJECTS_BY_ENTITYID = JOB_SERVICE + '/v1/job/assigned-jobs';
export const UPDATE_QUOTATION_STATUS = JOB_SERVICE + '/v1/job/quotation/updateStatus';
export const UPDATE_PO_STATUS = JOB_SERVICE + '/v1/job/purchase-order/updateStatus';
export const GET_BILLINGS = JOB_SERVICE + '/v1/billing';
export const FETCH_BILLING_SUMMARY = JOB_SERVICE + '/v1/billing/summary';
export const FETCH_SIGNED_DOCUMENT = JOB_SERVICE + '/v1/job/create-contract-doc';

// Employment
export const API_EMPLOYMENT = JOB_SERVICE + '/v1/employment';
export const API_EMPLOYMENT_LIST = JOB_SERVICE + '/v1/employment/getAllEmployment';
export const API_EMPLOYMENT_HISTORY = JOB_SERVICE + '/v1/employmentHistory';
export const API_EMPLOYMENT_HISTORY_COORDINATES = API_EMPLOYMENT_HISTORY + '/coordinates';
export const API_EMPLOYMENT_ADMINISTRATION = JOB_SERVICE + '/v1/employment/admin';
export const API_EMPLOYMENT_ASSIGN_JOB_ADMIN = JOB_SERVICE + '/v1/job/assignment/fulfiler';
export const API_ASSIGN_ENTITY_IN_PROJECT = JOB_SERVICE + '/v1/job/link/jobentity';

export const API_EMPLOYMENT_GET_JOB_ADMIN = JOB_SERVICE + '/v1/job/assignment/fulfilment';
export const API_GET_ASSIGNED_ADMINS = JOB_SERVICE + '/v1/job/assignment/details';

// GAI API

export const API_GAI = PREFIX + GAI_SERVICE + '/v1/customai/chat';

// Job Seeker SERVICE

export const API_JOB_SEEKER = JOB_SEEKER_SERVICE + '/v1/jobseeker';
export const API_SEEKER_PREFERENCE = JOB_SEEKER_SERVICE + '/v1/jobpreference';
export const CREATE_EMPLOYEMENT_ORDER = ORDER_SERVICE + '/api/v1/order';
// Payment
export const API_PAYMENT = JOB_SEEKER_SERVICE + '/v1/payment';
export const API_RECHARGE_REQUESTS = ORDER_SERVICE + PREFIX + '/v1/payment/enterprise/wallet/recharge';
export const API_WALLET_BALANCE = ORDER_SERVICE + PREFIX + '/v1/payment/enterprise/wallet';
export const API_PAYOUT = ORDER_SERVICE + '/api/v1/payment/enterprise/payout';
export const BANK_ACCOUNT_DETAILS = API_AUTH + '/v1/enterprise/account-details';
export const PAYMENT_VERIFY_OTP = API_AUTH + '/v1/enterprise/payment/verify/otp';
export const PAYMENT_VIA_CREDIT = ORDER_SERVICE + PREFIX + '/v1/payment/enterprise/wallet-transfer';
export const DOWNLOAD_CREDITS = ORDER_SERVICE + PREFIX + '/v1/payment/enterprise/wallet/recharge/download';
export const DOWNLOAD_WITHDRAWAL_STATEMENT = ORDER_SERVICE + PREFIX + '/v1/payment/enterprise/payout/download';


// Work Log
export const API_FETCH_WORKLOG = JOB_SERVICE + '/v1/worklog';

// Profile Status Detail
export const API_PROFILE_STATUS_DETAIL = JOB_SEEKER_SERVICE + '/v1/profileStatusDetail';

// Rating

export const API_EMPLOYER_RATING = PREFIX + RATING_SERVICE + '/v1/employer';
export const API_JOB_SEEKER_RATING = PREFIX + RATING_SERVICE + '/v1/jobseeker';

/** Notification SERVICE */

export const API_NOTIFICATION = NOTIFICATION_SERVICE + '/v1/notification';

//Invoice
export const API_INVOICE = JOB_SERVICE + '/v1/invoice';
export const API_INVOICE_SUMMARY = JOB_SERVICE + '/v1/invoice/summary';
export const API_INVOICE_BY_ID = JOB_SERVICE + '/v1/invoice/unsecured';
export const API_BULK_INVOICES_PAY = ORDER_SERVICE + '/api/v1/order/bulk/invoice';
export const API_INVOICE_SETTLE = JOB_SERVICE + '/v1/invoice/settle';

//Supervisor Admin
export const REFERRAL_SERVICE = '/referral-service';
export const API_CHAMP = PREFIX + REFERRAL_SERVICE + '/v1/champ';
export const API_REFERRAL = PREFIX + REFERRAL_SERVICE + '/v1/referral';
export const API_COMMISSION = PREFIX + REFERRAL_SERVICE + '/v1/commission';
export const API_GET_JOBSUPERVISORS = API_AUTH + '/v2/account';
export const API_GET_JOBSUPERVISOR_BY_ID = JOB_SEEKER_SERVICE + '/v1/jobseeker/fetch-job-seeker-summary-by-ref-ids';
export const API_GET_JOBSUPERVISOR_EARNING_COMMISSION = PREFIX + REFERRAL_SERVICE + '/v1/commission/summary';


// JOB ADMIN 
export const ASSIGN_CHAMP = JOB_SERVICE + '/v1/job/assignment/fulfilment';


//Property
export const API_PROPERTY = JOB_SERVICE + '/v1/enterprise/property';
export const API_PROPERTY_FOR_ENTERPRISES = JOB_SERVICE + '/v1/enterprise/property/search-societies';
export const API_BOOKING = API_PROPERTY + '/booking';
export const API_PROPERTY_DOCUMENT = API_AUTH + '/v1/fileupload/PROPERTY_DOCUMENTS';
export const API_PROPERTY_EXPORT = API_PROPERTY + '/download';
export const API_BOOK = API_PROPERTY + '/enquiry';
export const API_FETCH_BOOKINGS = API_PROPERTY + '/fetch-booking';
export const ADD_QUOTATION = API_PROPERTY + '/add-quotation';


// WORK ORDER
export const API_WORK_ORDER = API_ENTERPRISE_ADMIN + '/enterprise/workOrder';
export const API_DOWNLOAD_WO_FULFILMENT = API_ENTERPRISE_ADMIN + '/enterprise/workOrder/download-wo-fulfilment';
export const API_ADD_WO_FULFILMENT = API_ENTERPRISE_ADMIN + '/enterprise/workOrder/bulk-fulfillment';
export const API_WORK_ORDER_APPROVE = API_ENTERPRISE_ADMIN + '/workOrder/approve';
export const API_WORK_ORDER_AGENCY_APPROVE = API_ENTERPRISE_ADMIN + '/enterprise/workOrder/changeStatus';
export const API_WORK_ORDER_REJECT = API_ENTERPRISE_ADMIN + '/workOrder/reject';
export const API_WORK_ORDER_EXPORT = API_ENTERPRISE_ADMIN + '/enterprise/workOrder/download';
export const API_WORK_ORDER_GOOGLE_AUTHORIZE = API_ENTERPRISE_ADMIN + '/google-sheets/authorize';
export const API_WORK_ORDER_GOOGLE_CALLBACK = API_ENTERPRISE_ADMIN + '/google-sheets/oauth2callback';
export const API_FETTCH_ASSIGNED_VENDORS = API_ENTERPRISE_ADMIN + '/job/assigned-vendors';
export const API_BULK_WORK_ORDER = API_WORK_ORDER + '/excel'


export const API_GET_ROLES_BY_ENTITY_NAME = API_AUTH + '/v1/enterprise/role';
export const API_GET_SUMMARY = API_ENTERPRISE_ADMIN + '/enterprise/workOrder/summary';

export const UPLOAD_SIGNATURE = JOB_SERVICE + '/v1/fileupload/signature';

export const UploadAttendancePictureChunk = JOB_SERVICE + '/v1/fileupload/workOrderhistory/chunks/';
export const ProcessAttendancePictureChunk = JOB_SERVICE + '/v1/fileupload/workOrderhistory/processChunks/';

export const API_ADD_VENDOR = API_AUTH + '/v1/enterprise/add-entity/';


//Subscription-Plans
export const FETCH_ALL_SUBSCRIPTION_PLANS = API_AUTH + '/v1/subscription/plan/hoa';
export const API_SUBSCRIBE_PLAN = API_AUTH + '/v1/subscription';
export const API_ACTIVATE_SUBSCRIPTION = API_AUTH + '/v1/subscription/activate';
export const FETCH_CURRENT_USER_SUBSCRIPTION = API_AUTH + '/v1/subscription';


// Roles & Permissions
export const FETCH_PERMISSIONS = API_AUTH + '/v1/enterprise/role/permissions';
export const CRETE_ROLE_WITH_PERMISSIONS = API_AUTH + '/v1/enterprise/role';

// Project Type
export const API_PROJECT_TYPE = API_ENTERPRISE_ADMIN + '/enterprise/projectType';

// Services
export const API_SERVICES = API_ENTERPRISE_ADMIN + '/enterprise/services';
export const API_SERVICETYPES = API_SERVICES + '/service-type';

// Breifing Form 
export const API_BRIEFING_FORM = API_ENTERPRISE_ADMIN + '/enterprise/briefingForm';

// Breifing Form Values
export const API_BRIEFING_FORM_VALUES = API_ENTERPRISE_ADMIN + '/enterprise/briefingFormValues';

// Digital Portfolio
export const API_GET_MARKETPLACES = API_AUTH + '/v1/enterprise/digital-portfolios';
export const API_GET_DIGITAL_PORTFOLIOS_SERVICES = JOB_SERVICE + '/v1/enterprise/services/digital-portfolio-services';

export const API_DOWNLOAD_CALLING_TEMPLATE = 'sample-data/sample_leads.xlsx';
export const API_SEND_CALLING_TEMPLATE = API_AUTH + '/v1/enterprise/hourlyAgentLeads/excel';
export const API_GET_CALLING_TEMPLATE = API_AUTH + '/v1/enterprise/hourlyAgentLeads';
export const API_CALL_MAKE = PROJECT_API + 'call';
export const API_GET_CALL_MADE = PROJECT_API + 'getAllJobsStatus';
export const API_UPDATE_JOB_STATUS = PROJECT_API + 'getAllJobsStatusByClient';
export const API_UPDATE_JOBS_STATUS_HUMAN_REVIEW = PROJECT_API + 'updateJobsStatusHumanReview';
// A person taking a lead's WhatsApp / website chat over from the AI (activity history).
export const API_CHAT_TAKEOVER = PROJECT_API + 'chatTakeover';
export const API_CHAT_HUMAN_REPLY = PROJECT_API + 'chatHumanReply';
export const API_UPDATE_TASK_COMPLETION = PROJECT_API + 'updateTaskCompletion';
export const API_APPROVE_ADD_IN_OTHER_PROJECT = PROJECT_API + 'approveAddInOtherProject';

// Tasks API
export const GET_TASKS = PROJECT_API + 'getTasks';
export const GET_TASK = PROJECT_API + 'getTask';
export const CREATE_TASK = PROJECT_API + 'createTask';
export const CREATE_TASKS_BY_OUTCOME = PROJECT_API + 'createTasksByOutcome';
export const CREATE_TASKS_BY_SIGNAL = PROJECT_API + 'createTasksBySignal';
export const UPDATE_TASK = PROJECT_API + 'updateTask';
export const TASK_ACTION = PROJECT_API + 'taskAction';

// Per-entity API keys (Settings → API keys)
export const CREATE_ENTITY_API_KEY = PROJECT_API + 'createEntityApiKey';
export const LIST_ENTITY_API_KEYS = PROJECT_API + 'listEntityApiKeys';
export const DELETE_ENTITY_API_KEY = PROJECT_API + 'deleteEntityApiKey';

/** GET — project_id required; optional client_number for single-lead zip */
export const DOWNLOAD_PROJECT_WHATSAPP_DOCUMENTS = PROJECT_API + 'downloadProjectWhatsAppDocuments';

export const API_GET_JOB_SEEKER_DETAILS_BY_ENTITYID = JOB_SEEKER_SERVICE + '/v1/jobseeker/get-by-entityId/';



export const GET_ALL_AGENTS = PROJECT_API + 'getAgent';
export const GET_ALL_PROJECTS = PROJECT_API + 'getProject';
export const CREATE_PROJECT = PROJECT_API + 'createProject';
export const UPDATE_PROJECT = PROJECT_API + 'updateProject';
export const DELETE_PROJECT = PROJECT_API + 'deleteProject';
export const GET_AGENT = PROJECT_API + 'getAgent';
export const GET_ALL_AGENTS_LIST = PROJECT_API + 'getAllAgents';
export const GET_ALL_OUTCOMES = PROJECT_API + 'getAgentOutcomes';
export const CREATE_LEADS_USER = PROJECT_API + 'uploadProjectData';

export const VALIDATE_GOOGLE_TOKEN = GOOGLE_INTEGRATION_API + 'verifyMeetToken';
export const REFRESH_GOOGLE_TOKEN = GOOGLE_INTEGRATION_API + 'generateRefreshToken';

//Calling Service
export const API_VIDEO_STREAM = CALLING_SERVICE + '/videostream';
export const API_KEYWORD = CALLING_SERVICE + '/keyword';
export const API_DETECTION = CALLING_SERVICE + '/detect';

export const FETCH_RECRUITMENT_CANDIDATES = PROJECT_API + 'fetchRecruitmentCandidates';
export const FETCH_CANDIDATE_PERSONAL_DETAILS = PROJECT_API + 'fetchCandidatePersonalDetails';


export const PROJECT_HOA_URL = PROJECT_API + 'hoaProject';
/** Paginated project leads list (token-based). Prefer over project.leads on hoaProject. */
export const PROJECT_HOA_LEADS_URL = PROJECT_API + 'hoaProjectLeads';
export const PROJECT_CHAT_URL = PROJECT_API + 'hoaChatProject';
export const API_HOA_CLONE_PROJECT = PROJECT_API + 'hoaCloneProject';
export const FETCH_PERSONAL_DETAILS_HOA_URL = PROJECT_API + 'hoaRevealDetails';
export const FETCH_MORE_LEADS_HOA_URL = PROJECT_API + 'hoaFetchMoreLeads';
export const CREATE_LEADS_USER_HOA = PROJECT_API + 'hoaAddProjectLeads';
export const FETCH_CANDIDATE_DETAILS = PROJECT_API + 'hoaLead';
export const RUN_OUTREACH = PROJECT_API + 'hoaWorkflow';
export const CREDIT_USAGES_SUMMARY = PROJECT_API + 'creditUsageSummaries';
export const API_CREDIT_DASHBOARD = PROJECT_API + 'creditDashboard';
export const API_CREDIT_LEDGER = PROJECT_API + 'creditLedger';
export const API_CREDIT_EXPORT = PROJECT_API + 'creditExport';
export const API_CREDIT_EXPORT_STATUS = PROJECT_API + 'creditExportStatus';
export const GET_HOA_PROJECT_INITIAL_EMAIL_TEMPLATE = PROJECT_API + 'hoaProjectInitialEmailTemplate';
export const SEND_INITIAL_EMAIL = PROJECT_API + 'email';
export const DOWNLOAD_CONNECTED_LEADS_EXCEL = PROJECT_API + 'downloadConnectedLeadsExcel';
export const DOWNLOAD_CONNECTED_LEADS_EXCEL_STATUS = PROJECT_API + 'downloadConnectedLeadsExcelStatus';
export const HOA_ENTITY_OUTCOMES_FILTER = PROJECT_API + 'hoaEntityOutcomesFilter';
export const GENERATE_OUTCOME_DEFINITIONS = PROJECT_API + 'generateOutcomeDefinitions';

//reports
export const GET_REPORT_METRICS = PROJECT_API + 'getReportMetrics';

//project agent (chat inside a project)
export const PROJECT_AGENT_CHAT = PROJECT_API + 'projectAgentChat';
export const PROJECT_AGENT_THREAD = PROJECT_API + 'projectAgentThread';
export const PROJECT_AGENT_THREADS = PROJECT_API + 'projectAgentThreads';
export const PROJECT_AGENT_APPROVAL = PROJECT_API + 'projectAgentApproval';

//call analysis debug (INTERNAL only)
export const GET_CALL_ANALYSIS_LOGS = PROJECT_API + 'getCallAnalysisLogs';
export const GET_CALL_ANALYSIS_LOG = PROJECT_API + 'getCallAnalysisLog';
export const GET_CALL_ANALYSIS_PROMPT_TEMPLATE = PROJECT_API + 'getCallAnalysisPromptTemplate';
export const REPLAY_CALL_ANALYSIS = PROJECT_API + 'replayCallAnalysis';
export const REPLAY_CALL_ANALYSIS_BATCH = PROJECT_API + 'replayCallAnalysisBatch';
export const REEVALUATE_CALL_ANALYSIS = PROJECT_API + 'reevaluateCallAnalysis';
export const BACKFILL_JEV_OUTCOME = PROJECT_API + 'backfillJevOutcome';
export const START_BACKFILL_JEV_OUTCOME_PROJECT = PROJECT_API + 'backfillJevOutcomeProject';
export const BACKFILL_JEV_OUTCOME_PROJECT_STATUS = PROJECT_API + 'backfillJevOutcomeProjectStatus';
export const START_OUTCOME_ACCURACY_SEARCH = PROJECT_API + 'startOutcomeAccuracySearch';
export const OUTCOME_ACCURACY_SEARCH_STATUS = PROJECT_API + 'outcomeAccuracySearchStatus';
export const OUTCOME_ACCURACY_SEARCH_OUTCOMES = PROJECT_API + 'outcomeAccuracySearchOutcomes';
export const APPLY_OUTCOME_ACCURACY_SEARCH_RESULT = PROJECT_API + 'applyOutcomeAccuracySearchResult';

//websocket
export const API_WEB_SOCKET = environment.websocketURL;

//ICP
export const UPDATE_ICP_API = PROJECT_API + 'hoaUpdateProjectICP';
export const PROJECT_API_KEY = environment.projectAPIKey;
export const API_GET_UPLOAD_URL = PROJECT_API + 'get-upload-url';
export const API_GET_JOB_RECORD = PROJECT_API + 'getJobRecord';
export const API_UPLOAD_JOB_DOCUMENTS = PROJECT_API + 'uploadDocuments';
export const DOWNLOAD_LEADS_EXCEL = PROJECT_API + 'downloadLeadsExcel'
export const API_HOA_WORKFLOW_PAUSE = PROJECT_API + 'hoaWorkflowPause';
export const EDIT_PROJECT_TASKS = PROJECT_API + 'editProjectTasks';
export const EDIT_PROJECT_TASKS_STATUS = PROJECT_API + 'editProjectTasksStatus';
export const PROJECT_LEADS_STATUS_API = PROJECT_API + 'leadsStatusCount';
export const GET_OUTREACH_ACTIVITY_BUFFER = PROJECT_API + 'getOutreachActivityBuffer';

//Whatsapp Agent API
export const API_WHATSAPP_BASE = environment.whatsappAPI;
export const API_WHATSAPP_AGENT = environment.whatsappAPI + '/api/projects';
export const API_SEND_SINGLE_WHATSAPP_MSG = environment.whatsappAPI + '/api/send-message';

// New WhatsApp API endpoints (using PROJECT_API base)
export const API_WHATSAPP_SESSION = PROJECT_API + 'whatsappSession';
export const API_WHATSAPP_STATUS = PROJECT_API + 'whatsappStatus';
export const API_WHATSAPP_QR = PROJECT_API + 'whatsappQr';
export const API_WHATSAPP_AGENT_SEND = PROJECT_API + 'whatsappAgentSend';
export const API_WHATSAPP_WABA_ONBOARD = PROJECT_API + 'whatsappWabaOnboard';
export const API_WHATSAPP_SAVE_WABA = PROJECT_API + 'whatsappSaveWABA';
export const API_WHATSAPP_CONNECT_TO_PROJECT = PROJECT_API + 'whatsappConnectToProject';
export const API_WHATSAPP_LIST_WABAs = PROJECT_API + 'whatsappListWABAs';
export const API_WHATSAPP_CONNECT_INTERAKT = PROJECT_API + 'whatsappConnectInterakt';
export const API_WHATSAPP_DISCONNECT_FROM_PROJECT = PROJECT_API + 'whatsappDisconnectFromProject';
export const API_WHATSAPP_LIST_TEMPLATES = PROJECT_API + 'whatsappListTemplates';
export const API_WHATSAPP_CREATE_TEMPLATE = PROJECT_API + 'whatsappCreateTemplate';
export const API_WHATSAPP_GET_TEMPLATE_STATUS = PROJECT_API + 'whatsappGetTemplateStatus';
export const API_WHATSAPP_LIST_INTERAKT_TEMPLATES = PROJECT_API + 'whatsappListInteraktTemplates';
export const API_WHATSAPP_OUTREACH = PROJECT_API + 'whatsappOutreach';
export const API_WHATSAPP_UPLOAD_IMAGE = PROJECT_API + 'hoaUploadWhatsappImage';
export const API_UPDATE_PROJECT_NAME = PROJECT_API + 'updateProjectName';

// Serri external template API (base URL from environment; X-API-Key from environment.serriTemplatesApiKey)
const _serriTemplatesApiBase = (environment as { serriTemplatesApiUrl?: string }).serriTemplatesApiUrl;
const SERRI_TEMPLATES_API_BASE = _serriTemplatesApiBase
  ? String(_serriTemplatesApiBase).replace(/\/+$/, '')
  : '';
export const API_SERRI_TEMPLATES_CREATE_EXTERNAL = SERRI_TEMPLATES_API_BASE
  ? SERRI_TEMPLATES_API_BASE + '/templates/create-template'
  : '';

// Serri WhatsApp API endpoints (using PROJECT_API base)
export const API_SERRI_CONNECT_TO_PROJECT = PROJECT_API + 'serriConnectToProject';
export const API_SERRI_BULK_CAMPAIGN = PROJECT_API + 'serriBulkCampaign';
export const API_SERRI_CREATE_TEMPLATE = PROJECT_API + 'serriCreateTemplate';
export const API_SERRI_LIST_TEMPLATES = PROJECT_API + 'serriListTemplates';
export const API_SERRI_LIST_ACCOUNTS = PROJECT_API + 'serriListAccounts';
/** How many {{n}} placeholders a Serri template expects (drives template_variables mapping) */
export const API_SERRI_TEMPLATE_PLACEHOLDERS = PROJECT_API + 'serriTemplatePlaceholders';

// ── Arya account-level WhatsApp endpoints (assistantApiUrl base) ────────────
// These are distinct from the project-scoped PROJECT_API WhatsApp endpoints above.
// Auth and entity_id are handled by AssistantService.apiRequest — not added here.
const _ARYA_BASE = environment.assistantApiUrl;
export const ARYA_WA_CONNECT  = _ARYA_BASE + '/v1/assistant/whatsapp/connect';
export const ARYA_WA_QR       = _ARYA_BASE + '/v1/assistant/whatsapp/qr';
export const ARYA_WA_STATUS   = _ARYA_BASE + '/v1/assistant/whatsapp/status';
export const ARYA_WA_DISCONNECT = _ARYA_BASE + '/v1/assistant/whatsapp';
export const ARYA_CHAT_CANCEL = _ARYA_BASE + '/v1/assistant/chat/cancel';

// Billing rate cards — what each client is charged per minute of call time and per
// outbound WhatsApp message. Served by auth-service, which is the only place a super
// admin can be recognised; it proxies to the calling service where the cards live.
export const API_BILLING_CONFIG = API_AUTH + '/v1/enterprise/internal/billing-config';
